import { Link } from "react-router-dom";
import { links } from "../../constants/links";
import { useGlobalContext } from "../../store/context";
import BTC from "../../images/btc.jpg";
import { openLink } from "../../utils/services";

function NavbarModal() {
  const { closeNavbarModal } = useGlobalContext();
  return (
    <div className="">
      <div className="w-[50px] h-[50px] flex justify-center items-center ml-2 animate-pulse">
        <img className="object-cover rounded-full" src={BTC} alt="" />
      </div>
      <div className="grid grid-cols-2 gap-2 p-3">
        {links.map((link) => (
          <Link to={link.url} key={link.id} onClick={closeNavbarModal}>
            <div className="hover:border flex items-center gap-2 px-2 py-1 rounded-full cursor-pointer group hover:border-[#fcd535]">
              <div className="group-hover:bg-[#ff9900] group-hover:bg-opacity-10 rounded-full cursor-pointer  transition duration-200 ease-out flex justify-center items-center  w-8 h-8 group-hover:text-[#fcd535]">
                {link.icon}
              </div>
              <span>{link.label}</span>
            </div>
          </Link>
        ))}
      </div>

      <div
        onClick={() => openLink("https://www.btcgroup.win/index")}
        className="flex justify-center cursor-pointer"
      >
        <div className="p-2 w-4/5 flex justify-center bg-[#fcd535] text-gray-900 rounded-md">
          Get Started
        </div>
      </div>

      <div className="mt-16 flex justify-end mx-3 relative">
        <div className="w-[50px] h-[50px] flex justify-center items-center ">
          <img className="object-cover rounded-full" src={BTC} alt="" />
        </div>

        <div className="w-2 h-2 bg-green-600 absolute rounded-full animate-ping"></div>
      </div>
    </div>
  );
}

export default NavbarModal;
